import React from "react";
import styled from "styled-components";
import { ChevronDown } from "@sonder/ui/source/icons";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { getTaskOptionByType } from "tasks/helpers";
import { SubjectTypeConfig } from "tasks/hooks/useCreateTaskFormConfig";
import { TypeEnum } from "typings/globalGQLTypes";

const StyledDropdownContent = styled(DropdownContent)`
  flex-direction: column;
  button {
    border-color: transparent;
    margin: 0.1rem 0;
  }
`;

interface Props {
  value?: TypeEnum;
  subjectType: SubjectTypeConfig;
  onChange: (selectedType?: TypeEnum) => void;
  disabled?: boolean;
}

export const TaskTypePicker = ({
  value,
  subjectType,
  onChange,
  disabled = false,
}: Props) => {
  const selectedTaskOption = value ? getTaskOptionByType(value) : null;
  const taskTypeOptions = subjectType.validTaskTypes
    .map(taskType => getTaskOptionByType(taskType))
    .filter(
      taskTypeOption => Boolean(taskTypeOption) && taskTypeOption?.taskType,
    );

  return (
    <Dropdown
      trigger={
        <Button fullWidth disabled={disabled}>
          {selectedTaskOption?.displayName || "Select Task Type"}
          <ChevronDown />
        </Button>
      }
    >
      {({ isOpen, closePortal }) =>
        isOpen && (
          <StyledDropdownContent>
            {taskTypeOptions.map(taskTypeOption => (
              <Button
                fullWidth
                key={taskTypeOption?.taskType}
                onClick={() => {
                  onChange(taskTypeOption?.taskType);
                  closePortal();
                }}
              >
                {taskTypeOption?.displayName}
              </Button>
            ))}
          </StyledDropdownContent>
        )
      }
    </Dropdown>
  );
};
